// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function makeThemeColor(theme) {
  return {
          TAG: /* Main */0,
          _0: theme === "Dark" ? "White" : "Black"
        };
}

function toMainColor(color) {
  if (color === "Text" || color === "Grey" || color === "Arte" || color === "Background" || color === "CorporateMenuText" || color === "Error" || color === "Success" || color === "Secondary" || color === "CorporateMenuIcon" || color === "HoverGrey" || color === "Actualite" || color === "LightGrey" || color === "White" || color === "TextAlternative" || color === "Primary" || color === "Black") {
    return {
            TAG: /* Main */0,
            _0: color
          };
  } else {
    return {
            TAG: /* Main */0,
            _0: "White"
          };
  }
}

function makeStyle(asset, colorOpt, displayOpt, weightOpt, sizeOpt, lineHeightOpt, decoration, style, hover, alignment, truncateLine, whiteSpace, param) {
  var color = colorOpt !== undefined ? colorOpt : ({
        TAG: /* Main */0,
        _0: "Text"
      });
  var display = displayOpt !== undefined ? Caml_option.valFromOption(displayOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline");
  var weight = weightOpt !== undefined ? weightOpt : "Regular";
  var size = sizeOpt !== undefined ? Caml_option.valFromOption(sizeOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");
  var lineHeight = lineHeightOpt !== undefined ? lineHeightOpt : "S";
  return {
          asset: asset,
          color: color,
          display: display,
          lineHeight: lineHeight,
          size: size,
          weight: weight,
          decoration: decoration,
          style: style,
          hover: hover,
          alignment: alignment,
          truncateLine: truncateLine,
          whiteSpace: whiteSpace
        };
}

var $$default = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var cta = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Secondary"
    }, undefined, "SemiBold", undefined, "XXS", undefined, undefined, {
      TAG: /* Main */0,
      _0: "Secondary"
    }, undefined, undefined, undefined, undefined);

function makeCtaWithAsset(asset) {
  return {
          asset: asset,
          color: cta.color,
          display: cta.display,
          lineHeight: cta.lineHeight,
          size: cta.size,
          weight: cta.weight,
          decoration: cta.decoration,
          style: cta.style,
          hover: cta.hover,
          alignment: cta.alignment,
          truncateLine: cta.truncateLine,
          whiteSpace: cta.whiteSpace
        };
}

function makeWhiteCta(asset) {
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "Black"
            }, undefined, "SemiBold", undefined, "XXS", undefined, undefined, {
              TAG: /* Main */0,
              _0: "Black"
            }, undefined, undefined, undefined, undefined);
}

var afterRight = makeStyle(undefined, undefined, undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var textfield = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeIcon(position) {
  return {
          TAG: /* Icon */1,
          _0: {
            position: position,
            icon: "Play",
            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
          }
        };
}

var left = makeStyle(makeIcon({
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var right = makeStyle(makeIcon({
          TAG: /* Right */1,
          _0: Particle_Screen_Constants.xsInnerSpace
        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var alone = makeStyle(makeIcon(/* Alone */0), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Icon = {
  makeIcon: makeIcon,
  left: left,
  right: right,
  alone: alone
};

function makeLogo(position) {
  return {
          TAG: /* Logo */0,
          _0: {
            position: position,
            logo: "ArteHorizontalLogo"
          }
        };
}

var left$1 = makeStyle({
      TAG: /* Logo */0,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        logo: "ArteHorizontalLogo"
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var right$1 = makeStyle({
      TAG: /* Logo */0,
      _0: {
        position: {
          TAG: /* Right */1,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        logo: "ArteHorizontalLogo"
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var alone$1 = makeStyle({
      TAG: /* Logo */0,
      _0: {
        position: /* Alone */0,
        logo: "ArteHorizontalLogo"
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Logo = {
  makeLogo: makeLogo,
  left: left$1,
  right: right$1,
  alone: alone$1
};

var WithAsset = {
  Icon: Icon,
  Logo: Logo
};

var Stories = {
  WithAsset: WithAsset
};

var listItem = makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "listItem")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var listItemUnderline = makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "listItem")), undefined, undefined, undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

function makeExternal(s) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Left */0,
                  _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
                },
                icon: "Arrow",
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeDownload(color, param) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Left */0,
                  _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                },
                icon: "Download",
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
              }
            }, color, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
}

var makeSuccess = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
        },
        icon: {
          NAME: "CircleCheck",
          VAL: "Success"
        },
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
      }
    }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function make(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", "L", undefined, "S")), "XXS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "XL", undefined, "L")), "XXS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else {
    return cta;
  }
}

var button_asset = {
  TAG: /* Icon */1,
  _0: {
    position: {
      TAG: /* Right */1,
      _0: Particle_Screen_Constants.xsInnerSpace
    },
    icon: {
      NAME: "Angle",
      VAL: [
        "Right",
        "Black"
      ]
    },
    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
  }
};

var button_color = {
  TAG: /* Main */0,
  _0: "Black"
};

var button_display = cta.display;

var button_lineHeight = cta.lineHeight;

var button_size = cta.size;

var button_weight = cta.weight;

var button_decoration = cta.decoration;

var button_style = cta.style;

var button_hover = {
  TAG: /* Main */0,
  _0: "Black"
};

var button_alignment = cta.alignment;

var button_truncateLine = cta.truncateLine;

var button_whiteSpace = cta.whiteSpace;

var button = {
  asset: button_asset,
  color: button_color,
  display: button_display,
  lineHeight: button_lineHeight,
  size: button_size,
  weight: button_weight,
  decoration: button_decoration,
  style: button_style,
  hover: button_hover,
  alignment: button_alignment,
  truncateLine: button_truncateLine,
  whiteSpace: button_whiteSpace
};

var EventZone = {
  make: make,
  button: button
};

function makeContentCollection(s) {
  if (typeof s === "object") {
    if (s.NAME === "Cta") {
      return makeStyle({
                  TAG: /* Icon */1,
                  _0: {
                    position: {
                      TAG: /* Left */0,
                      _0: Particle_Screen_Constants.xsInnerSpace
                    },
                    icon: {
                      NAME: "Angle",
                      VAL: [
                        "Left",
                        "White"
                      ]
                    },
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                  }
                }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    
  } else {
    if (s === "Subtitle") {
      return makeStyle(undefined, undefined, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    if (s === "Title") {
      return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "XL")), "XS", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    if (s === "Desc") {
      return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    
  }
  return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeTopBanner(s) {
  if (typeof s === "object") {
    if (s.NAME === "Cta") {
      return makeStyle({
                  TAG: /* Icon */1,
                  _0: {
                    position: {
                      TAG: /* Left */0,
                      _0: Particle_Screen_Constants.xsInnerSpace
                    },
                    icon: {
                      NAME: "Angle",
                      VAL: [
                        "Left",
                        "White"
                      ]
                    },
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                  }
                }, {
                  TAG: /* Main */0,
                  _0: "White"
                }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, "Shadow", undefined, undefined, undefined, undefined, undefined, undefined);
    }
    
  } else {
    if (s === "Subtitle") {
      return makeStyle(undefined, {
                  TAG: /* Main */0,
                  _0: "White"
                }, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    if (s === "Title") {
      return makeStyle(undefined, {
                  TAG: /* Main */0,
                  _0: "White"
                }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, 3, undefined, 2)), undefined, undefined);
    }
    
  }
  return makeStyle(undefined, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeTopTeaserPresse(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none")), "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else {
    return cta;
  }
}

function makeTopTeaser(asset, s) {
  var makeCtaStyle = function (asset, color) {
    return makeStyle(asset, color, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  };
  if (typeof s === "object") {
    if (s.NAME === "Cta") {
      var match = s.VAL;
      if (match === "Disabled") {
        return makeCtaStyle(asset, {
                    TAG: /* Main */0,
                    _0: "LightGrey"
                  });
      } else if (match === "Default") {
        return makeStyle(asset, undefined, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      } else {
        return makeCtaStyle(undefined, {
                    TAG: /* Main */0,
                    _0: "Black"
                  });
      }
    }
    
  } else {
    if (s === "Subtitle") {
      return makeStyle(undefined, undefined, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Left", undefined, undefined, "Center")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    if (s === "Title") {
      return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Left", undefined, undefined, "Center")), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    if (s === "Desc") {
      return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    
  }
  return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var makeSecondaryCta = makeStyle(undefined, undefined, undefined, "SemiBold", undefined, "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeSecondaryCtaWithAsset(asset) {
  return {
          asset: asset,
          color: makeSecondaryCta.color,
          display: makeSecondaryCta.display,
          lineHeight: makeSecondaryCta.lineHeight,
          size: makeSecondaryCta.size,
          weight: makeSecondaryCta.weight,
          decoration: makeSecondaryCta.decoration,
          style: makeSecondaryCta.style,
          hover: makeSecondaryCta.hover,
          alignment: makeSecondaryCta.alignment,
          truncateLine: makeSecondaryCta.truncateLine,
          whiteSpace: makeSecondaryCta.whiteSpace
        };
}

var ctaWithSmallResponsiveSize = makeStyle(undefined, undefined, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeSecondaryCtaWithSmallResponsiveSizeAndAsset(color, asset) {
  return makeStyle(asset, color, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeIcon$1(fill, size) {
  return {
          TAG: /* Icon */1,
          _0: {
            position: {
              TAG: /* Left */0,
              _0: Particle_Screen_Constants.xsInnerSpace
            },
            icon: {
              NAME: "Heart",
              VAL: fill
            },
            size: size
          }
        };
}

function makeProgramPage(fill) {
  var size = Particle_Screen_Ds.make("XXS", "XS", undefined, undefined, undefined, "S");
  return makeStyle(makeIcon$1(fill, size), undefined, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeSmall(fill) {
  return makeCtaWithAsset({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: {
                  NAME: "Heart",
                  VAL: fill
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")
              }
            });
}

function makeTeaser(fill) {
  return makeSecondaryCtaWithAsset(makeIcon$1(fill, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")));
}

function makeTeaserHover(fill) {
  var asset = makeIcon$1(fill, Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS"));
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "SemiBold", undefined, "XS", undefined, undefined, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, undefined, undefined);
}

var Favorite = {
  makeSmall: makeSmall,
  makeProgramPage: makeProgramPage,
  makeContentCollection: makeProgramPage,
  makeTeaser: makeTeaser,
  makeTeaserHover: makeTeaserHover
};

function makeIcon$2(icon) {
  return {
          TAG: /* Icon */1,
          _0: {
            position: /* Alone */0,
            icon: icon,
            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
          }
        };
}

var pause = makeStyle(makeIcon$2("Pause"), {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var play = makeStyle(makeIcon$2("Play"), {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeArrow(direction) {
  return makeCtaWithAsset(makeIcon$2({
                  NAME: "Angle",
                  VAL: [
                    direction,
                    "Black"
                  ]
                }));
}

var bullet = makeStyle(undefined, undefined, undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Carousel = {
  pause: pause,
  play: play,
  makeArrow: makeArrow,
  bullet: bullet
};

var title = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeNoResults(icon) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: Belt_Option.getWithDefault(icon, "Rocket"),
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXL")
              }
            }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var Search = {
  title: title,
  makeNoResults: makeNoResults
};

function make$1(s) {
  if (typeof s === "object") {
    if (s.NAME === "Cta") {
      return makeStyle(undefined, {
                  TAG: /* Main */0,
                  _0: "White"
                }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, {
                  TAG: /* Main */0,
                  _0: "LightGrey"
                }, undefined, undefined, undefined, undefined);
    }
    
  } else if (s === "Desc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Light", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
  return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeTitle(status) {
  var asset = status !== undefined ? ({
        TAG: /* Icon */1,
        _0: {
          position: {
            TAG: /* Left */0,
            _0: Particle_Screen_Constants.xsInnerSpace
          },
          icon: {
            NAME: "Angle",
            VAL: [
              status ? "Down" : "Top",
              "White"
            ]
          },
          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
        }
      }) : undefined;
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var title$1 = makeTitle(undefined);

function makePartner(logo) {
  return makeStyle({
              TAG: /* Logo */0,
              _0: {
                position: /* Alone */0,
                logo: logo
              }
            }, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "Light", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeSocial(socialMedia) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Left */0,
                  _0: Particle_Screen_Constants.xsInnerSpace
                },
                icon: socialMedia === "Instagram" ? ({
                      NAME: "Instagram",
                      VAL: "Footer"
                    }) : (
                    socialMedia === "Twitter" ? ({
                          NAME: "Twitter",
                          VAL: "Footer"
                        }) : (
                        socialMedia === "Youtube" ? ({
                              NAME: "Youtube",
                              VAL: "Footer"
                            }) : ({
                              NAME: "Facebook",
                              VAL: "Footer"
                            })
                      )
                  ),
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            }, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, {
              TAG: /* Main */0,
              _0: "LightGrey"
            }, undefined, undefined, undefined, undefined);
}

var newsletter = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var textfield$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var european = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Footer = {
  make: make$1,
  makeTitle: makeTitle,
  title: title$1,
  makePartner: makePartner,
  makeSocial: makeSocial,
  newsletter: newsletter,
  textfield: textfield$1,
  european: european
};

function makeTos(s) {
  if (s === "Desc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, "Underline", undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, undefined, undefined);
  }
}

function makeFeedback(s) {
  if (s === "Error") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Error"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Success"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

var label = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var current = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var selectItem = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var listItem$1 = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Dropdown = {
  current: current,
  selectItem: selectItem,
  listItem: listItem$1,
  label: label
};

function makeSocial$1(value) {
  var tmp;
  switch (value) {
    case /* Facebook */0 :
        tmp = {
          NAME: "Facebook",
          VAL: "Sharebar"
        };
        break;
    case /* Twitter */1 :
        tmp = {
          NAME: "Twitter",
          VAL: "Sharebar"
        };
        break;
    case /* Whatsapp */2 :
        tmp = "Whatsapp";
        break;
    
  }
  return {
          asset: {
            TAG: /* Icon */1,
            _0: {
              position: /* Alone */0,
              icon: tmp,
              size: Particle_Screen_Ds.make(undefined, undefined, undefined, "XL", undefined, "S")
            }
          },
          color: {
            TAG: /* Main */0,
            _0: "White"
          },
          display: cta.display,
          lineHeight: cta.lineHeight,
          size: cta.size,
          weight: cta.weight,
          decoration: cta.decoration,
          style: cta.style,
          hover: undefined,
          alignment: cta.alignment,
          truncateLine: cta.truncateLine,
          whiteSpace: cta.whiteSpace
        };
}

var Sharebar = {
  makeSocial: makeSocial$1
};

var cta$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var link = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Regular", undefined, undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var warningCta = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "M", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var warningSecondaryCta = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "M", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var warningLink = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "M", undefined, "XS")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var ctaWarningMessage = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "M", undefined, "XS")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var ctaWarningMessageHighlighted = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "M", undefined, "XS")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var makeDefault = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "L", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeTitle$1 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", "XXL", undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeSubtitle = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", "L", undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDate = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "LightGrey"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "L", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeHoverChapter = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "M", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeHoverNextChapter = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "S", undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeProgramTitle = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", "XXL", undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeMessage = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", "L", undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Player = {
  cta: cta$1,
  link: link,
  warningCta: warningCta,
  warningSecondaryCta: warningSecondaryCta,
  warningLink: warningLink,
  ctaWarningMessage: ctaWarningMessage,
  ctaWarningMessageHighlighted: ctaWarningMessageHighlighted,
  makeDefault: makeDefault,
  makeTitle: makeTitle$1,
  makeSubtitle: makeSubtitle,
  makeDate: makeDate,
  makeHoverChapter: makeHoverChapter,
  makeHoverNextChapter: makeHoverNextChapter,
  makeProgramTitle: makeProgramTitle,
  makeMessage: makeMessage
};

function makeSetting(s) {
  if (typeof s === "object") {
    if (s.VAL === "Active") {
      return makeStyle(undefined, toMainColor("Secondary"), undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    } else {
      return makeStyle(undefined, {
                  TAG: /* Main */0,
                  _0: "Black"
                }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
  } else if (s === "ItemMessage") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "MessageLink") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "MobileTitle") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), "XS", "Underline", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "ItemDesc") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "XL")), "S", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "ItemTitle") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "S")), "XXS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inline")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

function make$2(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "inline", undefined, undefined, "none")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return cta;
  }
}

function makePlayNext(s) {
  if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return cta;
  }
}

function makeAfp(s) {
  if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "inline", undefined, undefined, "none")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

function makeInfo(s) {
  if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XL")), "XXS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "inline", undefined, undefined, "none")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

function makeWhite(s) {
  if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "inline", undefined, undefined, "none")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

var downloadAll = makeCtaWithAsset({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Download",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
      }
    });

var seeMore = makeCtaWithAsset({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Right */1,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: {
          NAME: "Angle",
          VAL: [
            "Right",
            undefined
          ]
        },
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    });

var seeMorePlayNext = makeWhiteCta({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Right */1,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: {
          NAME: "Angle",
          VAL: [
            "Right",
            undefined
          ]
        },
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    });

function makeNav(direction) {
  return makeCtaWithAsset({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: {
                  NAME: "Angle",
                  VAL: [
                    direction,
                    "Black"
                  ]
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            });
}

var Slider = {
  make: make$2,
  makePlayNext: makePlayNext,
  makeAfp: makeAfp,
  makeInfo: makeInfo,
  makeWhite: makeWhite,
  downloadAll: downloadAll,
  seeMore: seeMore,
  seeMorePlayNext: seeMorePlayNext,
  makeNav: makeNav
};

function disable(t) {
  return {
          asset: t.asset,
          color: {
            TAG: /* Main */0,
            _0: "LightGrey"
          },
          display: t.display,
          lineHeight: t.lineHeight,
          size: t.size,
          weight: t.weight,
          decoration: t.decoration,
          style: t.style,
          hover: t.hover,
          alignment: t.alignment,
          truncateLine: t.truncateLine,
          whiteSpace: t.whiteSpace
        };
}

function make$3(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else {
    return cta;
  }
}

function makeCollection(level) {
  if (level === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Text"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Text"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);
  }
}

function toParent(t) {
  return t;
}

function makeAfp$1(s) {
  var init = make$3(s);
  return {
          asset: init.asset,
          color: {
            TAG: /* Main */0,
            _0: "White"
          },
          display: init.display,
          lineHeight: init.lineHeight,
          size: init.size,
          weight: init.weight,
          decoration: init.decoration,
          style: init.style,
          hover: init.hover,
          alignment: init.alignment,
          truncateLine: init.truncateLine,
          whiteSpace: init.whiteSpace
        };
}

function makePlayNext$1(s) {
  var init = make$3(s);
  return {
          asset: init.asset,
          color: {
            TAG: /* Main */0,
            _0: "White"
          },
          display: init.display,
          lineHeight: init.lineHeight,
          size: init.size,
          weight: init.weight,
          decoration: init.decoration,
          style: init.style,
          hover: init.hover,
          alignment: init.alignment,
          truncateLine: init.truncateLine,
          whiteSpace: init.whiteSpace
        };
}

function makeInfo$1(s) {
  if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  }
}

function makeWhite$1(s) {
  var init = make$3(s);
  return {
          asset: init.asset,
          color: {
            TAG: /* Main */0,
            _0: "Black"
          },
          display: init.display,
          lineHeight: init.lineHeight,
          size: init.size,
          weight: init.weight,
          decoration: init.decoration,
          style: init.style,
          hover: init.hover,
          alignment: init.alignment,
          truncateLine: init.truncateLine,
          whiteSpace: init.whiteSpace
        };
}

var makeGenre = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

function makeGuide(s) {
  if (typeof s === "object") {
    if (s.NAME === "Cta" && s.VAL === "Default") {
      return makeStyle(undefined, {
                  TAG: /* Main */0,
                  _0: "LightGrey"
                }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, "S", "XS")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
    }
    
  } else {
    if (s === "Subtitle") {
      return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, "S", "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);
    }
    if (s === "Title") {
      return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, "M", "S")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
    }
    
  }
  return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var date = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, "M", "S")), undefined, "Capitalize", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), /* NoWrap */0, undefined);

function make$4(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 3)), undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "White"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  }
}

function cta$2(asset, param) {
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var trailerCta = cta$2({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Play",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    }, undefined);

var portraitDesc = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 4)), undefined, undefined);

var genreLink = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "LightGrey"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

function toParent$1(t) {
  return t;
}

var Hover = {
  make: make$4,
  cta: cta$2,
  trailerCta: trailerCta,
  portraitDesc: portraitDesc,
  genreLink: genreLink,
  toParent: toParent$1
};

var geoblocking = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: /* Alone */0,
        icon: "Geoblocking",
        size: Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "XL")
      }
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Teaser = {
  make: make$3,
  makePlayNext: makePlayNext$1,
  makeAfp: makeAfp$1,
  makeInfo: makeInfo$1,
  makeWhite: makeWhite$1,
  makeGenre: makeGenre,
  date: date,
  toParent: toParent,
  disable: disable,
  makeCollection: makeCollection,
  makeGuide: makeGuide,
  geoblocking: geoblocking,
  Hover: Hover
};

var title$2 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var TeaserCollection = {
  title: title$2
};

function title$3(variant) {
  return makeStyle(undefined, {
              TAG: /* Main */0,
              _0: "Text"
            }, undefined, "Bold", Caml_option.some(variant ? Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS") : Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);
}

var subtitle = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);

var description = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);

var category = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, "Underline", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);

function toParent$2(t) {
  return t;
}

var Broadcast = {
  title: title$3,
  subtitle: subtitle,
  description: description,
  category: category,
  toParent: toParent$2
};

var desc = makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "inline", undefined, undefined, "none")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, 1, undefined, undefined, undefined)), undefined, undefined);

function makeCat(cat, weight) {
  if (cat === "Default") {
    return makeStyle(undefined, undefined, undefined, weight, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Category */1,
                _0: cat
              }, undefined, weight, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, {
                TAG: /* Category */1,
                _0: cat
              }, undefined, undefined, undefined, undefined);
  }
}

function $$default$1(weight) {
  return makeCat("Default", weight);
}

function actualite(weight) {
  return makeCat("Actualite", weight);
}

function cinema(weight) {
  return makeCat("Cinema", weight);
}

function serie(weight) {
  return makeCat("Serie", weight);
}

function culture(weight) {
  return makeCat("Culture", weight);
}

function concert(weight) {
  return makeCat("Concert", weight);
}

function science(weight) {
  return makeCat("Science", weight);
}

function voyage(weight) {
  return makeCat("Voyage", weight);
}

function histoire(weight) {
  return makeCat("Histoire", weight);
}

var Breadcrumb = {
  desc: desc,
  makeCat: makeCat,
  $$default: $$default$1,
  actualite: actualite,
  cinema: cinema,
  serie: serie,
  culture: culture,
  concert: concert,
  science: science,
  voyage: voyage,
  histoire: histoire
};

var time = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XS", undefined, undefined, "XXS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var base = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XS", undefined, undefined, "XXS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);

var direct = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XS", undefined, undefined, "XXS")), undefined, "Uppercase", undefined, undefined, undefined, undefined, undefined, undefined);

var live = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XS", undefined, undefined, "XXS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var highlight = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XS", undefined, undefined, "XXS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);

var tag = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var firstBroadcastDate = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "ComingSoon",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
      }
    }, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var outline = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "XXS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var time$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXS", undefined, "XS", "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var base$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXS", undefined, "XS", "XS")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1)), undefined, undefined);

var direct$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXS", undefined, "XS", "XS")), undefined, "Uppercase", undefined, undefined, undefined, undefined, undefined, undefined);

var TeaserGuide = {
  time: time$1,
  base: base$1,
  direct: direct$1
};

var Sticker = {
  time: time,
  base: base,
  direct: direct,
  live: live,
  highlight: highlight,
  tag: tag,
  firstBroadcastDate: firstBroadcastDate,
  outline: outline,
  TeaserGuide: TeaserGuide
};

function make$5(s, asset, hover) {
  if (typeof s === "object" && s.NAME === "Cta" && s.VAL === "Active") {
    return makeStyle(asset, {
                TAG: /* Main */0,
                _0: "Black"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
  }
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, hover, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
}

function makeUserPanel(asset) {
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "Text"
            }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
}

function makeLanguageSwitcher(s) {
  if (typeof s === "object" && s.NAME === "Cta" && s.VAL === "Active") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
  }
  return makeStyle(undefined, {
              TAG: /* Main */0,
              _0: "White"
            }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
}

function makeMenuNavigation(asset, s) {
  if (typeof s === "object" && s.NAME === "Cta" && s.VAL === "Active") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Black"
              }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "ML")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
  }
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "ML")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);
}

var concert$1 = makeStyle(undefined, {
      TAG: /* Category */1,
      _0: "Concert"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);

var makeSelectGenre = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "M", undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);

function makeConcertMenuNavigation(ffNewConcertHeader) {
  return makeStyle(undefined, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, "SemiBold", Caml_option.some(ffNewConcertHeader ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M") : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "ML")), "M", undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);
}

function concertLogo(status) {
  return makeCtaWithAsset({
              TAG: /* Logo */0,
              _0: {
                position: /* Alone */0,
                logo: {
                  NAME: "ConcertLogo",
                  VAL: status
                }
              }
            });
}

var redirectionAnchor = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var installMobileApp = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), "XXS", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var Header = {
  make: make$5,
  makeUserPanel: makeUserPanel,
  makeLanguageSwitcher: makeLanguageSwitcher,
  makeMenuNavigation: makeMenuNavigation,
  concert: concert$1,
  makeSelectGenre: makeSelectGenre,
  makeConcertMenuNavigation: makeConcertMenuNavigation,
  concertLogo: concertLogo,
  redirectionAnchor: redirectionAnchor,
  installMobileApp: installMobileApp
};

function makeStorybook(s) {
  if (typeof s === "object") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "LightGrey"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Subdesc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "LightGrey"
              }, undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XL")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

function makeMessage$1(s) {
  if (typeof s === "object") {
    return makeStyle(undefined, undefined, undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* PreWrap */1, undefined);
  } else {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Secondary"
              }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Center", undefined, undefined, "Left")), undefined, /* PreWrap */1, undefined);
  }
}

function makeExpanderButton(direction) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Left */0,
                  _0: Particle_Screen_Constants.xsInnerSpace
                },
                icon: {
                  NAME: "Angle",
                  VAL: [
                    direction,
                    "Text"
                  ]
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            }, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
}

function make$6(s) {
  if (typeof s === "object" && s.NAME === "Cta" && s.VAL === "Default") {
    return makeStyle({
                TAG: /* Icon */1,
                _0: {
                  position: {
                    TAG: /* Left */0,
                    _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
                  },
                  icon: "Arrow",
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                }
              }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
  return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var ProgramExternal = {
  make: make$6
};

function make$7(s) {
  if (s === "Subtitle") {
    return makeStyle(undefined, undefined, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), "XS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Title") {
    return makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);
  } else if (s === "Desc") {
    return makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return cta;
  }
}

var makeDescBold = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeBuyProgramLink = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var makeLabel = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeValue = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeValueGenre = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "L", "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var ProgramContent = {
  make: make$7,
  makeDescBold: makeDescBold,
  makeBuyProgramLink: makeBuyProgramLink,
  makeLabel: makeLabel,
  makeValue: makeValue,
  makeValueGenre: makeValueGenre
};

var makeLabel$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), "M", undefined, undefined, undefined, undefined, undefined, /* PreWrap */1, undefined);

var makeTitle$2 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var PlayNextSimple = {
  makeLabel: makeLabel$1,
  makeTitle: makeTitle$2
};

var makeSwitchLabel = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makePaginatedGrid = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makePageList = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeColoredBox = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function make$8(s) {
  if (s === "Desc") {
    return makeStyle(undefined, {
                TAG: /* Main */0,
                _0: "Arte"
              }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, "Italic", undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);
  }
}

var Quote = {
  make: make$8
};

var makeTitle$3 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var makeSubtitle$1 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeInfo$2 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "LightGrey"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDefault$1 = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Left", undefined, undefined, "Center")), undefined, undefined, undefined);

var makeCta = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDescription = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Left", undefined, undefined, "Center")), undefined, undefined, undefined);

var makeLink = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var makeFooter = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeFooterLink = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);

var makeDropdown = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: /* Alone */0,
        icon: "Gear",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
      }
    }, {
      TAG: /* Main */0,
      _0: "Arte"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeCheckbox = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeTextfield = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);

var makeTvCellField = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, "SemiBold", undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var makeEventInfo = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeEventLink = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Arte"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var profileNavigationItemList = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "Left", undefined, undefined, "Right")), undefined, undefined, undefined);

function makeHeaderNavigationItemList(state) {
  return makeStyle(undefined, state ? ({
                  TAG: /* Main */0,
                  _0: "White"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Arte"
                }), undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeHeaderSecondaryNavigationItemList(state) {
  return makeStyle(undefined, state ? ({
                  TAG: /* Main */0,
                  _0: "White"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Arte"
                }), undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var makeEmailDisplaying = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Mona = {
  makeTitle: makeTitle$3,
  makeSubtitle: makeSubtitle$1,
  makeInfo: makeInfo$2,
  makeDefault: makeDefault$1,
  makeCta: makeCta,
  makeDescription: makeDescription,
  makeLink: makeLink,
  makeFooter: makeFooter,
  makeFooterLink: makeFooterLink,
  makeDropdown: makeDropdown,
  makeCheckbox: makeCheckbox,
  makeTextfield: makeTextfield,
  makeTvCellField: makeTvCellField,
  makeEventInfo: makeEventInfo,
  makeEventLink: makeEventLink,
  profileNavigationItemList: profileNavigationItemList,
  makeHeaderNavigationItemList: makeHeaderNavigationItemList,
  makeHeaderSecondaryNavigationItemList: makeHeaderSecondaryNavigationItemList,
  makeEmailDisplaying: makeEmailDisplaying
};

function make$9(state) {
  var commonStyle = function (color) {
    return makeStyle(undefined, toMainColor(color), undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  };
  if (state) {
    return commonStyle("Primary");
  } else {
    return commonStyle("Secondary");
  }
}

var SelectGenre = {
  make: make$9
};

function makeToggleButton(status) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Left */0,
                  _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                },
                icon: {
                  NAME: "Angle",
                  VAL: [
                    status === "active" ? "Down" : "Right",
                    "Black"
                  ]
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            }, {
              TAG: /* Main */0,
              _0: "Black"
            }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeMenuItem(asset, highlight) {
  var color = highlight ? "White" : "CorporateMenuText";
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: color
            }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);
}

var menuItem = makeMenuItem(undefined, false);

var menuItemCurrent = makeMenuItem(undefined, true);

function makeMenuItemWithChilds(highlight, status) {
  var direction = status ? "Down" : "Top";
  var background = highlight ? "White" : "Background";
  var asset = {
    TAG: /* Icon */1,
    _0: {
      position: {
        TAG: /* Right */1,
        _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      },
      icon: {
        NAME: "Angle",
        VAL: [
          direction,
          background
        ]
      },
      size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
    }
  };
  return makeMenuItem(asset, highlight);
}

function makeMenuItemChild(highlight) {
  return makeMenuItem(undefined, highlight);
}

var makeSearchForm = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Background"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeSearchButton(status) {
  var asset = {
    TAG: /* Icon */1,
    _0: {
      position: /* Alone */0,
      icon: status ? ({
            NAME: "Search",
            VAL: "CorporateMenuIcon"
          }) : ({
            NAME: "MessageClose",
            VAL: undefined
          }),
      size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
    }
  };
  return makeMenuItem(asset, false);
}

var Corporate = {
  makeToggleButton: makeToggleButton,
  makeSearchForm: makeSearchForm,
  menuItem: menuItem,
  makeMenuItemWithChilds: makeMenuItemWithChilds,
  menuItemCurrent: menuItemCurrent,
  makeMenuItemChild: makeMenuItemChild,
  makeSearchButton: makeSearchButton
};

var menuBrandTitle = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "S")), undefined, "Uppercase", undefined, undefined, undefined, undefined, undefined, undefined);

function makeMenuItem$1(asset) {
  return makeStyle(asset, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);
}

var menuItem$1 = makeMenuItem$1(undefined);

var menuItemCurrent$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Grey"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, /* NoWrap */0, undefined);

function makeMenuItemWithChilds$1(status) {
  var direction = status ? "Down" : "Top";
  return makeMenuItem$1({
              TAG: /* Icon */1,
              _0: {
                position: {
                  TAG: /* Right */1,
                  _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                },
                icon: {
                  NAME: "Angle",
                  VAL: [
                    direction,
                    "White"
                  ]
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
              }
            });
}

var makeCheckbox$1 = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeHightlightFilter = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeSearchButton$1(status) {
  return makeMenuItem$1({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: status ? ({
                      NAME: "Search",
                      VAL: "CorporateMenuIcon"
                    }) : "MenuClose",
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
              }
            });
}

var makeTitle$4 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeSubtitle$2 = makeStyle(undefined, undefined, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeInfo$3 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "LightGrey"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDefault$2 = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDropdown$1 = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: /* Alone */0,
        icon: "Gear",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
      }
    }, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeTextfield$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Left")), undefined, undefined, undefined);

function makeWeekSlider(status) {
  return makeStyle(undefined, status ? ({
                  TAG: /* Main */0,
                  _0: "Text"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Arte"
                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var makeWeekSliderTooltip = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var makeGuideDownload_asset = {
  TAG: /* Icon */1,
  _0: {
    position: /* Alone */0,
    icon: "Download",
    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
  }
};

var makeGuideDownload_color = {
  TAG: /* Main */0,
  _0: "Text"
};

var makeGuideDownload_display = ctaWithSmallResponsiveSize.display;

var makeGuideDownload_lineHeight = ctaWithSmallResponsiveSize.lineHeight;

var makeGuideDownload_size = ctaWithSmallResponsiveSize.size;

var makeGuideDownload_weight = ctaWithSmallResponsiveSize.weight;

var makeGuideDownload_decoration = ctaWithSmallResponsiveSize.decoration;

var makeGuideDownload_style = ctaWithSmallResponsiveSize.style;

var makeGuideDownload_hover = ctaWithSmallResponsiveSize.hover;

var makeGuideDownload_alignment = ctaWithSmallResponsiveSize.alignment;

var makeGuideDownload_truncateLine = ctaWithSmallResponsiveSize.truncateLine;

var makeGuideDownload_whiteSpace = ctaWithSmallResponsiveSize.whiteSpace;

var makeGuideDownload = {
  asset: makeGuideDownload_asset,
  color: makeGuideDownload_color,
  display: makeGuideDownload_display,
  lineHeight: makeGuideDownload_lineHeight,
  size: makeGuideDownload_size,
  weight: makeGuideDownload_weight,
  decoration: makeGuideDownload_decoration,
  style: makeGuideDownload_style,
  hover: makeGuideDownload_hover,
  alignment: makeGuideDownload_alignment,
  truncateLine: makeGuideDownload_truncateLine,
  whiteSpace: makeGuideDownload_whiteSpace
};

function makeNav$1(direction) {
  return makeCtaWithAsset({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: {
                  NAME: "Angle",
                  VAL: [
                    direction,
                    "Black"
                  ]
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
              }
            });
}

function makeDay(status) {
  return makeStyle(undefined, status ? ({
                  TAG: /* Main */0,
                  _0: "Text"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Background"
                }), undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "L", undefined, "M")), undefined, "Capitalize", undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeDate$1(status) {
  return makeStyle(undefined, status ? ({
                  TAG: /* Main */0,
                  _0: "Text"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Background"
                }), undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var Presse = {
  menuBrandTitle: menuBrandTitle,
  menuItem: menuItem$1,
  makeMenuItemWithChilds: makeMenuItemWithChilds$1,
  menuItemCurrent: menuItemCurrent$1,
  makeSearchButton: makeSearchButton$1,
  makeTitle: makeTitle$4,
  makeSubtitle: makeSubtitle$2,
  makeInfo: makeInfo$3,
  makeDefault: makeDefault$2,
  makeCheckbox: makeCheckbox$1,
  makeHightlightFilter: makeHightlightFilter,
  makeDropdown: makeDropdown$1,
  makeWeekSlider: makeWeekSlider,
  makeTextfield: makeTextfield$1,
  makeGuideDownload: makeGuideDownload,
  makeWeekSliderTooltip: makeWeekSliderTooltip,
  makeNav: makeNav$1,
  makeDay: makeDay,
  makeDate: makeDate$1
};

var title$4 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), "S", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var desc$1 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "M", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

function makeDeviceIcon(icon) {
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: icon,
                size: Particle_Screen_Ds.make(undefined, undefined, {
                      NAME: "Height",
                      VAL: "XL"
                    }, undefined, undefined, {
                      NAME: "Height",
                      VAL: "L"
                    })
              }
            }, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var deviceDesktop = makeDeviceIcon("Desktop");

var deviceSmartPhone = makeDeviceIcon("SmartPhone");

var deviceTv = makeDeviceIcon({
      NAME: "Tv",
      VAL: undefined
    });

var deviceTablet = makeDeviceIcon("Tablet");

var OverFooter = {
  title: title$4,
  desc: desc$1,
  deviceDesktop: deviceDesktop,
  deviceSmartPhone: deviceSmartPhone,
  deviceTv: deviceTv,
  deviceTablet: deviceTablet
};

var title$5 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "XL", undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var cta$3 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Black"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var textfield$2 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var NewsletterZone = {
  title: title$5,
  cta: cta$3,
  textfield: textfield$2
};

var makeTitle$5 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "L", undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Modal = {
  makeTitle: makeTitle$5
};

var make500Title = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var make500Subtitle = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var make500cta = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Arte"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var make404Title = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "L")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var make404Subtitle = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var make404cta = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Home",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
      }
    }, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);

var Oops = {
  make500Title: make500Title,
  make500Subtitle: make500Subtitle,
  make500cta: make500cta,
  make404Title: make404Title,
  make404Subtitle: make404Subtitle,
  make404cta: make404cta
};

var makeTitle$6 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "L")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDate$2 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "TextAlternative"
    }, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeDefault$3 = makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeBacklink = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: {
          NAME: "Angle",
          VAL: [
            "Left",
            undefined
          ]
        },
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Papa = {
  makeTitle: makeTitle$6,
  makeDate: makeDate$2,
  makeDefault: makeDefault$3,
  makeBacklink: makeBacklink
};

var copyrightInside = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var copyrightOutside = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "TextAlternative"
    }, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeCopyright(position) {
  if (position) {
    return copyrightOutside;
  } else {
    return copyrightInside;
  }
}

var title$6 = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "Text"
    }, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), "S", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function toParent$3(t) {
  return t;
}

var ImageCaption = {
  makeCopyright: makeCopyright,
  title: title$6,
  toParent: toParent$3
};

var makeSecurityCenter = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined);

var makeUserPrefMessage = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var UserPref = {
  makeSecurityCenter: makeSecurityCenter,
  makeUserPrefMessage: makeUserPrefMessage
};

var title$7 = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, "L", undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Guide = {
  title: title$7
};

function getColorByStatus(status) {
  if (status) {
    return {
            TAG: /* Main */0,
            _0: "Text"
          };
  } else {
    return {
            TAG: /* Main */0,
            _0: "Background"
          };
  }
}

function makeDay$1(status) {
  return makeStyle(undefined, status ? ({
                  TAG: /* Main */0,
                  _0: "Text"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Background"
                }), undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, "Capitalize", undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeDate$3(status) {
  return makeStyle(undefined, status ? ({
                  TAG: /* Main */0,
                  _0: "Text"
                }) : ({
                  TAG: /* Main */0,
                  _0: "Background"
                }), undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var GuideTvCalendar = {
  getColorByStatus: getColorByStatus,
  makeDay: makeDay$1,
  makeDate: makeDate$3
};

function makeDefault$4(color) {
  return makeStyle(undefined, toMainColor(color), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function makeAndroidReleases(tag, color) {
  if (tag === "p") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "em") {
    return makeStyle(undefined, toMainColor(color), undefined, undefined, undefined, undefined, undefined, "Italic", undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h1") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h2") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h3") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "li") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "listItem")), undefined, undefined, "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "strong") {
    return makeStyle(undefined, toMainColor(color), undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, toMainColor(color), undefined, "SemiBold", undefined, undefined, "Underline", undefined, {
                TAG: /* Main */0,
                _0: "Arte"
              }, undefined, undefined, undefined, undefined);
  }
}

function makePapa(tag, color) {
  if (tag === "p") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "em") {
    return makeStyle(undefined, toMainColor(color), undefined, undefined, undefined, undefined, undefined, "Italic", undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h1") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "L")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h2") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "h3") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "block")), "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "li") {
    return makeStyle(undefined, toMainColor(color), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "listItem")), undefined, undefined, "L", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else if (tag === "strong") {
    return makeStyle(undefined, toMainColor(color), undefined, "Bold", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(undefined, toMainColor(color), undefined, undefined, undefined, undefined, "Underline", undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

var DangerousHtml = {
  makeDefault: makeDefault$4,
  makeAndroidReleases: makeAndroidReleases,
  makePapa: makePapa
};

var makeHeroTitle = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XXL", undefined, undefined, "L")), "XS", undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);

var makeHeroSubTitle = makeStyle(undefined, undefined, undefined, "Medium", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "XL", undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2)), undefined, undefined);

var makeHeroTutorial = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Info",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
      }
    }, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeHeroTutorialButton = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makePageTitle = makeStyle(undefined, undefined, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XL")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeListTitle = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

function makeReleaseTitle(theme) {
  return makeStyle(undefined, makeThemeColor(theme), undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), "M", undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

var makeCtaTutorial = makeStyle(undefined, {
      TAG: /* Main */0,
      _0: "White"
    }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeCtaDownload_asset = {
  TAG: /* Icon */1,
  _0: {
    position: {
      TAG: /* Left */0,
      _0: Particle_Screen_Constants.xsInnerSpace
    },
    icon: "Download",
    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
  }
};

var makeCtaDownload_color = {
  TAG: /* Main */0,
  _0: "White"
};

var makeCtaDownload_display = ctaWithSmallResponsiveSize.display;

var makeCtaDownload_lineHeight = ctaWithSmallResponsiveSize.lineHeight;

var makeCtaDownload_size = ctaWithSmallResponsiveSize.size;

var makeCtaDownload_weight = ctaWithSmallResponsiveSize.weight;

var makeCtaDownload_decoration = ctaWithSmallResponsiveSize.decoration;

var makeCtaDownload_style = ctaWithSmallResponsiveSize.style;

var makeCtaDownload_hover = ctaWithSmallResponsiveSize.hover;

var makeCtaDownload_alignment = ctaWithSmallResponsiveSize.alignment;

var makeCtaDownload_truncateLine = ctaWithSmallResponsiveSize.truncateLine;

var makeCtaDownload_whiteSpace = ctaWithSmallResponsiveSize.whiteSpace;

var makeCtaDownload = {
  asset: makeCtaDownload_asset,
  color: makeCtaDownload_color,
  display: makeCtaDownload_display,
  lineHeight: makeCtaDownload_lineHeight,
  size: makeCtaDownload_size,
  weight: makeCtaDownload_weight,
  decoration: makeCtaDownload_decoration,
  style: makeCtaDownload_style,
  hover: makeCtaDownload_hover,
  alignment: makeCtaDownload_alignment,
  truncateLine: makeCtaDownload_truncateLine,
  whiteSpace: makeCtaDownload_whiteSpace
};

var AndroidReleases = {
  makeHeroTitle: makeHeroTitle,
  makeHeroSubTitle: makeHeroSubTitle,
  makeHeroTutorial: makeHeroTutorial,
  makeHeroTutorialButton: makeHeroTutorialButton,
  makePageTitle: makePageTitle,
  makeListTitle: makeListTitle,
  makeReleaseTitle: makeReleaseTitle,
  makeCtaTutorial: makeCtaTutorial,
  makeCtaDownload: makeCtaDownload
};

var makeProgram = makeStyle(undefined, undefined, undefined, "Bold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "M")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var makeRc = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var Partners = {
  makeProgram: makeProgram,
  makeRc: makeRc
};

function view(param) {
  var truncateLine = param.truncateLine;
  var display = param.display;
  var asset = param.asset;
  var getDisplay = function (display, truncateLine) {
    if (display === "none") {
      return "none";
    } else if (truncateLine !== undefined) {
      return "webkitbox";
    } else {
      return display;
    }
  };
  var display$1 = asset !== undefined ? Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "flex") : (
      truncateLine !== undefined ? Particle_Screen_Ds.zipWith(getDisplay, display, Caml_option.valFromOption(truncateLine)) : display
    );
  return {
          asset: asset,
          color: param.color._0,
          display: display$1,
          family: "Barna",
          lineHeight: param.lineHeight,
          size: param.size,
          weight: param.weight,
          decoration: param.decoration,
          style: param.style,
          hover: Belt_Option.map(param.hover, (function (hover) {
                  return hover._0;
                })),
          alignment: param.alignment,
          truncateLine: truncateLine,
          whiteSpace: param.whiteSpace
        };
}

function close(color) {
  return makeCtaWithAsset({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: {
                  NAME: "MessageClose",
                  VAL: color
                },
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
              }
            });
}

var Message = {
  close: close
};

var title$8 = makeStyle(undefined, undefined, undefined, "Regular", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XL")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var link$1 = makeStyle(undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "L")), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var SiteMap = {
  title: title$8,
  link: link$1
};

var programEnabled = makeSecondaryCtaWithSmallResponsiveSizeAndAsset(undefined, {
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Play",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    });

var programDisabled = makeStyle({
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Play",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    }, {
      TAG: /* Main */0,
      _0: "Grey"
    }, undefined, "SemiBold", Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, "S", undefined, undefined, "XS")), "XS", undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var eventZone = makeSecondaryCtaWithSmallResponsiveSizeAndAsset({
      TAG: /* Main */0,
      _0: "White"
    }, {
      TAG: /* Icon */1,
      _0: {
        position: {
          TAG: /* Left */0,
          _0: Particle_Screen_Constants.xsInnerSpace
        },
        icon: "Play",
        size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
      }
    });

var Trailer = {
  programEnabled: programEnabled,
  programDisabled: programDisabled,
  eventZone: eventZone
};

function makeThemeSwitchButton(status) {
  var icon = status ? "BurgerMenu" : ({
        NAME: "Angle",
        VAL: [
          "Right",
          undefined
        ]
      });
  return makeStyle({
              TAG: /* Icon */1,
              _0: {
                position: /* Alone */0,
                icon: icon,
                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
              }
            }, {
              TAG: /* Main */0,
              _0: "White"
            }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "Center")), undefined, undefined, undefined);
}

var assetIconInnerSpace = Particle_Screen_Constants.xsInnerSpace;

exports.makeThemeColor = makeThemeColor;
exports.toMainColor = toMainColor;
exports.makeStyle = makeStyle;
exports.assetIconInnerSpace = assetIconInnerSpace;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.cta = cta;
exports.makeCtaWithAsset = makeCtaWithAsset;
exports.makeWhiteCta = makeWhiteCta;
exports.afterRight = afterRight;
exports.textfield = textfield;
exports.Stories = Stories;
exports.listItem = listItem;
exports.listItemUnderline = listItemUnderline;
exports.makeExternal = makeExternal;
exports.makeDownload = makeDownload;
exports.makeSuccess = makeSuccess;
exports.EventZone = EventZone;
exports.makeContentCollection = makeContentCollection;
exports.makeTopBanner = makeTopBanner;
exports.makeTopTeaserPresse = makeTopTeaserPresse;
exports.makeTopTeaser = makeTopTeaser;
exports.makeSecondaryCta = makeSecondaryCta;
exports.makeSecondaryCtaWithAsset = makeSecondaryCtaWithAsset;
exports.ctaWithSmallResponsiveSize = ctaWithSmallResponsiveSize;
exports.makeSecondaryCtaWithSmallResponsiveSizeAndAsset = makeSecondaryCtaWithSmallResponsiveSizeAndAsset;
exports.Favorite = Favorite;
exports.Carousel = Carousel;
exports.Search = Search;
exports.Footer = Footer;
exports.makeTos = makeTos;
exports.makeFeedback = makeFeedback;
exports.Dropdown = Dropdown;
exports.Sharebar = Sharebar;
exports.Player = Player;
exports.makeSetting = makeSetting;
exports.Slider = Slider;
exports.Teaser = Teaser;
exports.TeaserCollection = TeaserCollection;
exports.Broadcast = Broadcast;
exports.Breadcrumb = Breadcrumb;
exports.Sticker = Sticker;
exports.Header = Header;
exports.makeStorybook = makeStorybook;
exports.makeMessage = makeMessage$1;
exports.makeExpanderButton = makeExpanderButton;
exports.ProgramExternal = ProgramExternal;
exports.ProgramContent = ProgramContent;
exports.PlayNextSimple = PlayNextSimple;
exports.makeSwitchLabel = makeSwitchLabel;
exports.makePaginatedGrid = makePaginatedGrid;
exports.makePageList = makePageList;
exports.makeColoredBox = makeColoredBox;
exports.Quote = Quote;
exports.Mona = Mona;
exports.SelectGenre = SelectGenre;
exports.Corporate = Corporate;
exports.Presse = Presse;
exports.OverFooter = OverFooter;
exports.NewsletterZone = NewsletterZone;
exports.Modal = Modal;
exports.Oops = Oops;
exports.Papa = Papa;
exports.ImageCaption = ImageCaption;
exports.UserPref = UserPref;
exports.Guide = Guide;
exports.GuideTvCalendar = GuideTvCalendar;
exports.DangerousHtml = DangerousHtml;
exports.AndroidReleases = AndroidReleases;
exports.Partners = Partners;
exports.view = view;
exports.Message = Message;
exports.SiteMap = SiteMap;
exports.Trailer = Trailer;
exports.makeThemeSwitchButton = makeThemeSwitchButton;
/* default Not a pure module */
